import { LightningElement, api } from "lwc";

export default class extends LightningElement {
  @api variant: "badge" | "badge-error" = "badge";
}
